/**
 * Categorical palette for brand series, drawn from Tessra primitives.
 *
 * Deliberately NOT --chart-1/--chart-2: `styles/global.css` documents that those
 * are byte-identical to --chart-negative/--chart-positive, so a brand line drawn
 * in them reads as an alarm or a success rather than an identity.
 */
export const BRAND_COLOR_TOKENS: string[] = [
  'var(--color-blue-600)',
  'var(--color-purple-600)',
  'var(--color-green-600)',
  'var(--color-amber-500)',
  'var(--color-pink-600)',
  'var(--color-teal-600)',
];

/** Stable per-brand colour, keyed off position in the ordered brand list. */
export function brandColor(brand: string, orderedBrands: string[]): string {
  const index = orderedBrands.indexOf(brand);
  if (index < 0) return BRAND_COLOR_TOKENS[0];
  return BRAND_COLOR_TOKENS[index % BRAND_COLOR_TOKENS.length];
}
